import { unset } from "lodash"

export function transform(data: any, user?: string) {
    let input = data
    let analytics_view = data?.analytics_view
    unset(input, 'analytics_view')
    return {
        input,
        analytics_view,
        user,
    }
}